import { useState, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setActiveVehicle } from 'actions/vehicles'
import { getActiveVehicleId } from 'util/vehicle'
import { AccountSetting, DrivingProfile, ProfileVehicle } from 'types/profile'

export const useVehiclesViewModel = () => {
  const profile = useSelector<any, DrivingProfile>((state) => state.profile)
  const vehicles = useSelector<any, ProfileVehicle[]>((state) => state.vehicles)
  const accountSettings = useSelector<any, AccountSetting[]>((state) => state.accountSettings)
  const isLocked = useSelector<any, boolean>((state) => state.isLocked)

  const [activeVehicleId, setActiveVehicleId] = useState<number>()

  const dispatch = useDispatch()

  const setNullActiveVehicle = useCallback(
    (vehicles: ProfileVehicle[], profile_id: number) => {
      const mostRecentVehicle = vehicles.reduce(
        (mostRecent, current) => (current.details.id > mostRecent.details.id ? current : mostRecent),
        vehicles[0]
      )

      if (mostRecentVehicle) {
        setActiveVehicle(profile_id, mostRecentVehicle.details.id)(dispatch)
      }
    },
    [dispatch]
  )

  useEffect(() => {
    const activeVehicleId = getActiveVehicleId(vehicles)
    if (!activeVehicleId) {
      setNullActiveVehicle(vehicles, profile.id)
    } else {
      setActiveVehicleId(Number(activeVehicleId))
    }
  }, [dispatch, profile, accountSettings, vehicles, setNullActiveVehicle])

  const orderedVehicles = vehicles.sort((a, b) => {
    if (a.details.id === activeVehicleId) return -1
    if (b.details.id === activeVehicleId) return 1

    const aHasPlate = a.details.license_plate
    const bHasPlate = b.details.license_plate

    if (aHasPlate && !bHasPlate) return -1
    if (!aHasPlate && bHasPlate) return 1

    return 0
  })

  const vehicleLimitReached = orderedVehicles.length >= 5

  return {
    vehicles,
    orderedVehicles,
    activeVehicleId,
    isLocked,
    vehicleLimitReached,
  }
}
